/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Toast_Team_Add_ErrorInputs */



/**
* | output |
* | --- |
* | "Space created but team could not be added." |
*
* @param {Spaces_Wizard_Toast_Team_Add_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_team_add_error = /** @type {((inputs?: Spaces_Wizard_Toast_Team_Add_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Team_Add_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space wurde erstellt, aber das Team konnte nicht hinzugefügt werden.")
	return /** @type {LocalizedString} */ ("Space created but team could not be added.")
});